const defaultState = {
  walletAmount: "",
  walletCredits: [],
  defaultCard: {},
  subscriptionPlans: [],
  coupons: [],
};

const paymentReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "setWalletAmount":
      return {
        ...state,
        walletAmount: action.payload,
      };

    case "setWalletCredits":
      return {
        ...state,
        walletCredits: Array.isArray(action.payload) ? action.payload : [],
      };

    case "setDefaultCard":
      return {
        ...state,
        defaultCard: action.payload,
      };

    case "setPlans":
      return {
        ...state,
        subscriptionPlans: action.payload,
      };

    case "setCoupons":
      return {
        ...state,
        coupons: action.payload,
      };

    default:
      return state;
  }
};

export default paymentReducer;
